(function (angular) {
  "use strict";

  angular.module("app").service("ForumThreadsApi", threadsCategory);

  threadsCategory.$inject = ["$resource", "extendResource", "settings"];

  function threadsCategory($resource, extendResource, settings) {
    var resource = $resource(
      settings.apiBase + "/forum/threads/:threadId",
      {
        threadId: "@threadId",
      },
      {
        query: {
          method: "GET",
          responseType: "json",
          isArray: false,
        },
        update: {
          method: "PUT",
          responseType: "json",
        },
      },
    );

    return extendResource(resource);
  }
})(angular);
